import React from 'react';
import {
  SendToolbarProps,
  SearchTypeToggle,
  SearchInput,
  SetFilter,
  PriceFilter,
  AutoMatchControl,
  DensityDropdown,
  DownloadButton,
  DEFAULT_DISPLAY_MODE,
  DEFAULT_SORT_VALUE,
} from './sendToolbarControls';
import SendSortDropdown from './SendSortDropdown';
import { CollapseAllButton } from 'components/TraderListCollapse/TraderListCollapse';

/**
 * Desktop/laptop toolbar (≥768px). A single flex-wrap row — every control is
 * rendered inline. As the viewport narrows, controls hit their min-widths and
 * naturally wrap to additional rows. No JS-driven collapse, no overflow menu;
 * the mobile (<768px) layout is the only place that uses an alternate layout.
 */
export default function DesktopSendToolbar(props: SendToolbarProps) {
  const {
    onSearch,
    displayMode = DEFAULT_DISPLAY_MODE,
    onDisplayModeChange,
    initialSearchValue = '',
    searchType = 'card',
    onSearchTypeChange,
    globalAutoMatch = false,
    onGlobalAutoMatchToggle,
    matchSummary,
    isMatchIndexLoading = false,
    hasMatchIndexError = false,
    onRetryMatchIndex,
    priceMin,
    priceMax,
    onPriceMinChange,
    onPriceMaxChange,
    sortValue = DEFAULT_SORT_VALUE,
    onSortChange,
    isSortLoading = false,
    onExportCsv,
    isExporting = false,
    hasResults = false,
    selectedSets = [],
    onSelectedSetsChange,
    collapseAll = false,
    onCollapseAllToggle,
  } = props;

  return (
    <div className="send-toolbar-desktop">
      <div className="send-search-wrapper">
        <SearchTypeToggle
          searchType={searchType}
          onSearchTypeChange={onSearchTypeChange}
          attached
        />
        <SearchInput
          searchType={searchType}
          initialSearchValue={initialSearchValue}
          onSearch={onSearch}
          attached
        />
      </div>

      <SetFilter selectedSets={selectedSets} onSelectedSetsChange={onSelectedSetsChange} />

      <PriceFilter
        priceMin={priceMin}
        priceMax={priceMax}
        onPriceMinChange={onPriceMinChange}
        onPriceMaxChange={onPriceMaxChange}
      />

      <AutoMatchControl
        globalAutoMatch={globalAutoMatch}
        onGlobalAutoMatchToggle={onGlobalAutoMatchToggle}
        matchSummary={matchSummary}
        isMatchIndexLoading={isMatchIndexLoading}
        hasMatchIndexError={hasMatchIndexError}
        onRetryMatchIndex={onRetryMatchIndex}
        showSummary
      />

      <SendSortDropdown
        sortValue={sortValue}
        onSortChange={onSortChange}
        isSortLoading={isSortLoading}
      />

      <DensityDropdown displayMode={displayMode} onDisplayModeChange={onDisplayModeChange} />

      {onCollapseAllToggle && <CollapseAllButton collapseAll={collapseAll} onToggle={onCollapseAllToggle} />}

      <DownloadButton onExportCsv={onExportCsv} isExporting={isExporting} hasResults={hasResults} />
    </div>
  );
}
